
<div class="content">
    <iframe width="100%" height="350" [src]="videoUrl" 
            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>
    </iframe>
</div>